<ng-container *ngIf="isReadOnly; else showInputDatePicker">
  <div *ngIf="!dateReadonlyHint" class="p-text-bold-500">
    {{
      this.bindingFormControl?.value
        | date
          : (readOnlyDateFormatWithShowTime
              ? envConfig.format.datetimeHM
              : dateFormat ?? envConfig.format.datetime)
        | replaceNullWith : '-'
    }}
  </div>
  <div *ngIf="dateReadonlyHint" class="p-text-bold-500">
    <span class="p-text-red">
      {{
        this.bindingFormControl?.value
          | date : dateFormat ?? envConfig.format.datetime
          | replaceNullWith : '-'
      }}</span
    >
  </div>
</ng-container>
<ng-template #showInputDatePicker>
  <sigv-form-control-widget
    [fieldName]="fieldName"
    [bindingFormControl]="bindingFormControl"
  >
    <p-calendar
      [formControl]="bindingFormControl"
      [showIcon]="true"
      [selectionMode]="selectionMode"
      icon="pi pi-datepicker"
      [showTime]="showTime"
      [stepMinute]="stepMinute"
      [keepInvalid]="true"
      [view]="view"
      [defaultDate]="defaultDate"
      [dateFormat]="primeDateFormat"
      [selectionMode]="selectionMode"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [appendTo]="appendTo"
      [timeOnly]="timeOnly"
      [yearNavigator]="true"
      [monthNavigator]="true"
      [readonlyInput]="readonlyInput"
      [hideOnDateTimeSelect]="hideOnDateTimeSelect"
      [ngClass]="{ 'p-fluid': true }"
      [baseZIndex]="2000"
      [maxDate]="defaultMaxDate"
      [minDate]="defaultMinDate"
      [yearRange]="defaultYearRange"
      (onBlur)="onBlur($event)"
      (onInput)="onInput()"
      (onSelect)="onSelect($event)"
      (onFocus)="onFocus($event)"
      (onShow)="onShow($event)"
    >
      <ng-template pTemplate="footer">
        <div
          *ngIf="showTime && !timeOnly"
          class="p-calendar-time-footer"
          (click)="onPanelOKBtnClick()"
        >
          OK
        </div>
      </ng-template>
      <ng-template pTemplate="date" let-dateInfo>
        <div [attr.data-overlay-panel-id]="overlayPanelId">
          {{ dateInfo.day }}
        </div>
      </ng-template>
    </p-calendar>
  </sigv-form-control-widget>
  <ng-container
    *ngIf="control?.invalid && (control?.dirty || control?.touched)"
  >
    <small *ngIf="control?.errors?.['invalidDate']" class="p-error">
      {{ fieldName | translate }}
      {{ validationMsgMap.invalidDate | translate }}
    </small>
    <small *ngIf="control?.errors?.['minDate']" class="p-error">
      {{ fieldName | translate }}
      {{ validationMsgMap.invalidDate | translate }}
    </small>
  </ng-container>
</ng-template>
